/**
 * @packageDocumentation
 * @module API
 * @category Core
 */

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthDeviceService } from '../auth/services/auth-device.service';
import { APP_VERSION } from '../tokens';

/**
 * Добавление метаинформации по устройству в HTTP-запросы.
 *
 * @group Interceptors
 *
 * @param req
 * @param next
 * @returns
 */
export const authDeviceInterceptor: HttpInterceptorFn = (req, next) => {
  const authDeviceService = inject(AuthDeviceService);
  const appVersion = inject(APP_VERSION, { optional: true });

  const headers = req.headers
    .append('x-device-id', authDeviceService.getOrGenerate())
    .append('x-app-version', appVersion || 'unknown');

  return next(req.clone({ headers }));
};
